/*
  KR Maps 2026 — Journeys "How it works" (sections/kr-journeys-how.liquid):
  one moment, played by the page's scroll. The map on the wall is the stage.

  The stage holds still while its section scrolls by, and the story moves
  with the scroll: each moment has its stretch of the section, goes forward as
  the page goes down and back as it goes up, and stops when the scroll stops.
  (The stage follows the scroll a touch behind, so a wheel's notches glide.)
  The only thing that moves by itself is the camera's live view before the
  shutter.

  1. fly       The whole print, framed on the wall, four pins in it. The
               camera goes in to the pins; as it nears them the print becomes
               the photograph of them.
  2. raise     The app's camera comes up over the pins: a phone, beside the
               words, or the whole width of a screen held upright. What it
               shows is the wall behind it.
  3. capture   The shutter; the view blinks.
  4. detect    A light passes over the photo; the rest dims as a spotlight
               opens on each pin the app finds, a halo springing round it, and
               the count goes up: "4 pins found".
  5. reveal    The app's map comes out of the photograph in rings that start
               at each pin, in the order the trip came to them, the app's pin
               rising where each ring starts. Round the phone the wall is
               still paper. The app's header and tab bar slide in.
  6. photos    The wall goes out of focus. One photo comes in large, with the
               date and place it carries and a line to its pin, and drops onto
               it. The rest follow as four stacks, one pin after another:
               photos fly from each stack onto its pin, and the pin counts
               them in.
  7. trip      A fingertip taps the last pin, and the trip's route draws
               itself through the pins.
  8. open      The trip's own page comes in over the map, as the app's
               screens do, at the day the pin was reached.
  9. read      The page's photos go by under its map as the section is
               scrolled, from the whole trip on its map down into the first
               morning's walk, the line creeping from photo to photo: the
               app's own page, recorded (assets/kr-journeys-demo.js, held
               and driven by the scroll). No drive is scrubbed: a drive
               scrubbed by the wheel jumped. Beside the phone the stage
               becomes each place in turn.
  10. yours    At the end the stage lets the page go, and the phone is the
               visitor's: the photos scroll on under a wheel or a thumb, and
               Play opens the trip's film. Scrolled back up, the story has it
               again.

  Everything is laid out in the phone screen's own points (440 x 956). The
  print is its artwork (DATA.art: the app's zoom 4), and a point of the screen
  is at art = (x, y) + k * point on it; the photograph lies on the print by the
  points each copy of it covers (DATA.boxes). At rest the stage shows a point
  at O + k * point, O being where the screen's corner is, so the wall and the
  app's map are one picture. DATA comes from the build script
  (docs/journeys-how-demo); DATA.demo is where the trip's page is read from
  and to, in the page's own points of scroll.
*/
(function () {
  'use strict';

  var DATA = {"screen":[440,956],"map":[119,858],"centre":[220.0,330],"sprite":{"cols":6,"rows":4,"w":320,"h":240},"art":{"w":2815,"h":1605,"k":0.3535533905932738,"x":2221.15,"y":725.13,"frame":40},"boxes":{"wide":{"x":-580,"y":-420,"w":1610,"h":1720,"px":1.5},"tall":{"x":-300,"y":-420,"w":1040,"h":1720,"px":0.9},"lens":{"x":-24,"y":16,"w":488,"h":788,"px":2.0}},"pins":[{"id":"green","x":159.3,"y":267.5,"c":"#3E9B55","color":"green","ring":16.1},{"id":"blue","x":346.3,"y":290.3,"c":"#2B6FD0","color":"blue","ring":21.1},{"id":"yellow","x":132.7,"y":372.6,"c":"#F2C12E","color":"yellow","ring":17.5},{"id":"red","x":241.7,"y":389.6,"c":"#DB6035","color":"red","ring":18.5}],"order":["green","yellow","blue","red"],"stacks":[{"pin":"green","name":"Kumai","where":"Central Kalimantan","n":39,"cells":[0,1,2],"fly":[3,1,4,0]},{"pin":"blue","name":"Makale","where":"South Sulawesi","n":66,"cells":[5,6,7],"fly":[8,9,10,5]},{"pin":"yellow","name":"Semarang","where":"Central Java","n":101,"cells":[11,12,13],"fly":[14,12,15,11]},{"pin":"red","name":"Bedugul","where":"Bali","n":81,"cells":[16,17,18],"fly":[19,17,20,16]}],"one":{"pin":"red","tag":"Aug 14, 2025 · Bedugul, Bali"},"tap":"red","print":"Executive World","demo":{"trip":"bali","start":0,"end":6177,"places":[[3325,3645],[5510,5830]],"flights":[[34,530,2.587]]}};

  // Each moment's stretch of the section's scroll, from and to, in svh at the
  // section's own length (the track is 1150svh, which leaves 1040 to scroll);
  // a longer or a shorter track stretches them all alike. The gaps between
  // hold still, for the words. No moment is quicker than a wheel can show:
  // the first version's photos each flew in under a notch.
  var LEN = 1040;
  function span(a, b) { return [a / LEN, b / LEN]; }
  var SCENES = [
    span(4, 74),      // fly
    span(74, 98),     // raise
    span(102, 130),   // capture
    span(130, 180),   // detect
    span(194, 314),   // reveal
    span(330, 570),   // photos
    span(590, 650),   // trip: the tap, the route
    span(650, 690),   // open: the trip's page comes in
    span(700, 1000)   // read: its photos go by, its line draws on
  ];
  var FLY = 0, RAISE = 1, CAPTURE = 2, DETECT = 3, REVEAL = 4, PHOTOS = 5, TRIP = 6, OPEN = 7, READ = 8;
  var SAYS = [0, 10, 72, 196, 332, 588, 704, 1002].map(function (v) { return v / LEN; });   // when each moment's words come
  var PART_OF = [0, 0, 0, 1, 2, 2, 2, 2];                                                  // and the part each belongs to
  var PARTS = [span(0, 194), span(194, 330), span(330, 1016)];                             // the wall, the phone, the trips
  var GOALS = [0, 318 / LEN, 682 / LEN];                                                   // where a part's name scrolls to
  var FREE = 1022 / LEN;      // from here the phone is the visitor's
  // The trip's page is read at a steady pace through its photos, and each
  // flight of the camera gets scroll by how far it goes (its length in the
  // flight's own measure, from the recording), between a floor and a
  // ceiling: at the page's own pace a long flight passed in a notch.
  function flightSvh(length) { return clamp(14 * length, 14, 60); }
  var EASE = 0.14;            // how far the stage closes on the scroll in a 60th of a second
  // The app's pins, drawn larger than the app draws them so they read on a
  // phone this size; scaled from the tip of the stem, which stays on the place.
  var PIN = 2;
  var HEAD = 17.6 * PIN;      // from the tip up to the middle of the head
  var HEAD_R = 6.5 * PIN;     // the head's radius
  var W = DATA.screen[0];
  var H = DATA.screen[1];
  var MAP_TOP = DATA.map[0], MAP_BOT = DATA.map[1];
  var CY = DATA.centre[1];    // the pins' middle, in the screen's points
  var A = DATA.art;
  // The map comes out of the photograph: a ring starts at each pin RING_GAP
  // after the last, and is RING_LEN growing to RING_R points.
  var RING_0 = 0.10, RING_GAP = 0.13, RING_LEN = 0.42, RING_R = 860;
  // The photos' moments, as shares of their scene: the one photo, then a
  // stack every STACK_STEP; each stack's photos leave it over FLY_SPREAD from
  // FLY_0 after it comes, and each is FLY_LEN in the air. One pin at a time,
  // all on one way: eighteen photos on eighteen curves were "too chaotic".
  var ONE_IN = [0.03, 0.10], ONE_LINE = [0.10, 0.09], ONE_FLY = [0.24, 0.13];
  var STACK_0 = 0.40, STACK_STEP = 0.15, STACK_IN = 0.045;
  var FLY_0 = 0.03, FLY_SPREAD = 0.05, FLY_LEN = 0.07;
  var FAN = [[-7, -0.05, 0.04], [5, 0.055, -0.05], [0, 0, 0]];   // each photo of a stack: turn, and how far off (shares of its width)
  var ROUTE = ['#E58A36', '#D9623A', '#8E2F55', '#6B2A5B'];       // the route's colours, from its first day to its last

  var SVGNS = 'http://www.w3.org/2000/svg';

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function part(t, a, d) { return clamp((t - a) / d, 0, 1); }
  function bell(t) { return t <= 0 || t >= 1 ? 0 : Math.sin(Math.PI * t); }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function easeOutQuint(t) { return 1 - Math.pow(1 - t, 5); }
  function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
  function smooth(a, b, x) { var t = clamp((x - a) / (b - a), 0, 1); return t * t * (3 - 2 * t); }
  // A scrubbed moment should not ride a strong ease, or its middle goes by
  // in a notch: half straight, half eased.
  function gentle(t) { return 0.5 * t + 0.5 * smooth(0, 1, t); }
  function easeBack(t) { var c1 = 1.5, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); }
  // Where an ease reaches y: the moment a sweep gets to something.
  function inverse(fn, y) {
    var lo = 0, hi = 1;
    for (var i = 0; i < 30; i++) { var mid = (lo + hi) / 2; if (fn(mid) < y) lo = mid; else hi = mid; }
    return (lo + hi) / 2;
  }
  function plural(n, w) { return n + ' ' + w + (n === 1 ? '' : 's'); }
  function px(v) { return v.toFixed(2) + 'px'; }

  function init(root) {
    if (root.getAttribute('data-kr-how-init')) return;
    root.setAttribute('data-kr-how-init', '1');
    var q = function (sel) { return root.querySelector(sel); };
    var all = function (sel) { return [].slice.call(root.querySelectorAll(sel)); };
    var track = q('.kr-jhow__track'), stage = q('.kr-jhow__stage'), copy = q('.kr-jhow__copy');
    var phone = q('.kr-jhow__phone'), screen = q('.kr-jhow__screen');
    var map = q('.kr-jhow__map'), digital = q('.kr-jhow__digital'), routeEl = q('.kr-jhow__route'), ringsLayer = q('.kr-jcam__rings');
    var wall = q('.kr-jhow__wall'), lamp = q('.kr-jhow__lamp'), place = q('.kr-jhow__place'), shade = q('.kr-jhow__shade'), veil = q('.kr-jhow__veil');
    if (!track || !stage || !screen || !map || !digital || !wall) return;
    var wallImgs = all('.kr-jhow__w--wide, .kr-jhow__w--tall, .kr-jhow__w--lens'), soft = q('.kr-jhow__w--soft');
    var view = q('.kr-jcam__view'), dim = q('.kr-jcam__dim'), holesG = q('.kr-jcam__holes');
    var shimmer = q('.kr-jcam__shimmer'), blink = q('.kr-jcam__blink');
    var vf = q('.kr-jvf'), found = q('.kr-jvf__found'), foundTx = q('.kr-jvf__found b'), shutter = q('.kr-jvf__shutter i');
    var hdr = q('.kr-jhow__hdr'), tab = q('.kr-jhow__tab'), demoEl = q('.kr-jhow__demo'), placeImgs = all('.kr-jhow__place img');
    var one = q('.kr-jone'), card = q('.kr-jone__card'), tag = q('.kr-jone__tag'), line = q('.kr-jhow__line'), halo = q('.kr-jhow__halo');
    var stacksEl = q('.kr-jstacks');
    var says = all('.kr-jhow__say'), parts = all('.kr-jhow__part'), skip = q('.kr-jhow__skip'), end = q('.kr-jhow__end');
    var sprite = root.getAttribute('data-sprite');
    var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var tall = window.matchMedia ? window.matchMedia('(max-width: 860px) and (max-aspect-ratio: 1/1)') : { matches: false };

    function set(el, prop, value, cache, key) {
      if (!el || cache[key] === value) return;
      cache[key] = value;
      el.style[prop] = value;
    }
    function setVar(el, name, value, cache, key) {
      if (!el || cache[key] === value) return;
      cache[key] = value;
      el.style.setProperty(name, value);
    }

    // ── the trip's page in the phone: the Retrace demo, mounted by its own
    // script (assets/kr-journeys-demo.js), held while the story drives it ──
    var demo = null, wakeWanted = false, inited = false;
    var D = DATA.demo;
    // Where the read puts the page for each share of its scene: the holds
    // (photos going by) share the scroll by their length, each flight gets
    // its own by how far it goes.
    var readMap = (function () {
      if (!D) return null;
      var units = (SCENES[READ][1] - SCENES[READ][0]) * LEN;
      var flights = (D.flights || []).filter(function (f) { return f[1] > D.start && f[0] < D.end; });
      var holdPts = D.end - D.start, flown = 0;
      flights.forEach(function (f) { holdPts -= Math.min(f[1], D.end) - Math.max(f[0], D.start); flown += flightSvh(f[2] || 1); });
      var perPt = Math.max(0, units - flown) / Math.max(1, holdPts);
      var segs = [], at = 0, s = D.start;
      function add(to, span) { if (to <= s) return; segs.push({ a: at, b: at + span, s0: s, s1: to }); at += span; s = to; }
      flights.forEach(function (f) { add(Math.max(f[0], D.start), (Math.max(f[0], D.start) - s) * perPt); add(Math.min(f[1], D.end), flightSvh(f[2] || 1)); });
      add(D.end, (D.end - s) * perPt);
      var total = at || 1;
      return function (rd) {
        var u = rd * total;
        for (var i = 0; i < segs.length; i++) {
          var g = segs[i];
          if (u <= g.b || i === segs.length - 1) return g.s0 + (g.s1 - g.s0) * clamp((u - g.a) / (g.b - g.a || 1), 0, 1);
        }
        return D.end;
      };
    })();
    function onDemo(api) {
      demo = api;
      api.hold(true);
      if (D) api.drive(D.start);
      if (wakeWanted || still) api.wake();
      if (!inited) return;                       // the rest of the stage is laid out below, then it takes the phone in
      if (still) { fit(); render(0); api.hold(false); }
      else { fit(); kick(); }
    }
    if (demoEl) {
      if (demoEl.__krDemo) onDemo(demoEl.__krDemo);
      else demoEl.addEventListener('kr-demo-mounted', function () { onDemo(demoEl.__krDemo); }, { once: true });
      // Held upright, Play takes the whole screen: the page under it stands still.
      demoEl.addEventListener('kr-play-open', function () { if (upright) document.documentElement.classList.add('kr-jhow-film'); });
      demoEl.addEventListener('kr-play-close', function () { document.documentElement.classList.remove('kr-jhow-film'); });
    }
    function mask(el, value, cache) {
      if (cache.mask === value) return;
      cache.mask = value;
      el.style.webkitMaskImage = value;
      el.style.maskImage = value;
    }

    // ── the photograph, on the print and in the phone, by the points each
    // copy of it covers ──
    all('.kr-jhow__w').forEach(function (el) {
      var b = DATA.boxes[el.getAttribute('data-box')];
      el.style.left = px(A.x + b.x * A.k);
      el.style.top = px(A.y + b.y * A.k);
      el.style.width = px(b.w * A.k);
      el.style.height = px(b.h * A.k);
    });
    all('.kr-jcam__p').forEach(function (el) {
      var b = DATA.boxes[el.getAttribute('data-box')];
      el.style.left = b.x + 'px';
      el.style.top = b.y + 'px';
      el.style.width = b.w + 'px';
      el.style.height = b.h + 'px';
    });

    // ── the four pins: on the print, a dot each; in the photograph, when the
    // light finds each; in the app, when its ring starts ──
    var wallPins = DATA.pins, pinOf = {};
    wallPins.forEach(function (p) { pinOf[p.id] = p; });
    var DET = [0.08, 0.66];     // the shimmer's sweep within detect
    var dots = wallPins.map(function (p) {
      var el = document.createElement('i');
      el.className = 'kr-jhow__dot';
      el.style.left = px(A.x + p.x * A.k);
      el.style.top = px(A.y + p.y * A.k);
      el.style.setProperty('--c', p.c);
      wall.appendChild(el);
      return { el: el, c: {} };
    });
    var finds = wallPins.map(function (p) {
      var el = document.createElement('i');
      var r = p.ring + 7;
      el.className = 'kr-jring';
      el.style.left = p.x - r + 'px';
      el.style.top = p.y - r + 'px';
      el.style.width = el.style.height = 2 * r + 'px';
      var ripple = document.createElement('i');
      ripple.className = 'kr-jripple';
      ringsLayer.appendChild(ripple);
      ringsLayer.appendChild(el);
      var glow = document.createElement('i');
      glow.className = 'kr-jglow';
      glow.style.left = p.x + 'px';
      glow.style.top = p.y + 'px';
      ringsLayer.appendChild(glow);
      var hole = document.createElementNS(SVGNS, 'circle');
      hole.setAttribute('cx', p.x);
      hole.setAttribute('cy', p.y);
      hole.setAttribute('r', 0);
      hole.setAttribute('fill', '#000');
      holesG.appendChild(hole);
      // The shimmer's band is at x when its sweep is at (x + W/2) / 2W.
      var tFind = DET[0] + DET[1] * inverse(easeInOut, (p.x + W / 2) / (2 * W));
      // When its ring starts: in the order the trip came to the pins.
      var tRing = RING_0 + Math.max(0, DATA.order.indexOf(p.id)) * RING_GAP;
      return { p: p, el: el, ripple: ripple, glow: glow, hole: hole, R: r + 16, to: (HEAD_R + 4) / r, tFind: tFind, tRing: tRing, c: {}, rc: {} };
    });
    var RING_END = RING_0 + (wallPins.length - 1) * RING_GAP + RING_LEN;

    // ── the map's pins, only those in the photograph, drawn top to bottom so
    // a lower pin stands in front ──
    var pins = wallPins.slice().sort(function (a, b) { return a.y - b.y; }).map(function (p) {
      var el = document.createElement('i');
      el.className = 'kr-jpin';
      el.setAttribute('aria-hidden', 'true');
      el.style.left = p.x - 12 + 'px';
      el.style.top = p.y - MAP_TOP - 34 + 'px';
      el.style.setProperty('--c', p.c);
      el.innerHTML = '<i class="w"></i><i class="s"></i><i class="h"></i>';
      map.appendChild(el);
      return { el: el, p: p, find: finds.filter(function (f) { return f.p === p; })[0], c: {} };
    });

    // ── the trip's route through the pins, a bow from each to the next ──
    var segs = [];
    DATA.order.forEach(function (id, i) {
      var a = pinOf[id], b = pinOf[DATA.order[i + 1]];
      if (!a || !b) return;
      var dx = b.x - a.x, dy = b.y - a.y, len = Math.sqrt(dx * dx + dy * dy) || 1;
      var nx = -dy / len, ny = dx / len;
      if (ny > 0) { nx = -nx; ny = -ny; }       // the bow goes up the map
      var d = 'M' + a.x + ' ' + a.y + ' Q' + ((a.x + b.x) / 2 + nx * len * 0.24).toFixed(1) + ' ' + ((a.y + b.y) / 2 + ny * len * 0.24).toFixed(1) + ' ' + b.x + ' ' + b.y;
      var under = document.createElementNS(SVGNS, 'path'), over_ = document.createElementNS(SVGNS, 'path');
      [under, over_].forEach(function (el, j) {
        el.setAttribute('d', d);
        el.setAttribute('fill', 'none');
        el.setAttribute('stroke', j ? ROUTE[Math.min(i, ROUTE.length - 1)] : '#ffffff');
        el.setAttribute('stroke-opacity', j ? 1 : 0.65);
        el.setAttribute('stroke-width', j ? 3.5 : 7);
        el.setAttribute('stroke-linecap', 'round');
        routeEl.appendChild(el);
      });
      var n = over_.getTotalLength ? over_.getTotalLength() : len * 1.1;
      [under, over_].forEach(function (el) { el.style.strokeDasharray = n.toFixed(1); el.style.strokeDashoffset = n.toFixed(1); });
      segs.push({ els: [under, over_], n: n, c: {} });
    });

    // ── each pin's count of photos in, beside its head ──
    var badges = DATA.stacks.map(function (st, i) {
      var p = pinOf[st.pin];
      var left = DATA.stacks.some(function (other) {
        var o = pinOf[other.pin];
        return other !== st && o.x > p.x && o.x - p.x < 44 && Math.abs(o.y - p.y) < 30;
      });
      var el = document.createElement('b');
      el.className = 'kr-jbadge' + (p.color === 'yellow' || p.color === 'white' ? ' is-dark' : '');
      el.setAttribute('aria-hidden', 'true');
      el.style.left = p.x + (left ? -1 : 1) * (HEAD_R + 3) + 'px';
      el.style.top = p.y - MAP_TOP - HEAD + 'px';
      el.style.transformOrigin = (left ? '100%' : '0%') + ' 50%';
      el.style.setProperty('--c', p.c);
      map.appendChild(el);
      return { el: el, i: i, total: st.n, first: st.pin === DATA.one.pin ? 1 : 0, last: '', tx: left ? '-100%' : '0%' };
    });

    // A photo from the sprite, whatever size it is drawn.
    var S_ = DATA.sprite;
    function photoBg(el, cell) {
      el.style.backgroundImage = 'url("' + sprite + '")';
      el.style.backgroundSize = S_.cols * 100 + '% ' + S_.rows * 100 + '%';
      el.style.backgroundPosition = ((cell % S_.cols) / (S_.cols - 1)) * 100 + '% ' + (S_.rows > 1 ? (Math.floor(cell / S_.cols) / (S_.rows - 1)) * 100 : 0) + '%';
    }

    // ── the stacks beside the phone, one for each pin ──
    var stacks = DATA.stacks.map(function (st) {
      var el = document.createElement('div');
      el.className = 'kr-jstack';
      el.style.setProperty('--c', pinOf[st.pin].c);
      var pile = document.createElement('span');
      pile.className = 'kr-jstack__pile';
      var cards = st.cells.map(function (cell) {
        var ph = document.createElement('i');
        ph.className = 'kr-jstack__ph';
        photoBg(ph, cell);
        pile.appendChild(ph);
        return { el: ph, c: {} };
      });
      var name = document.createElement('span');
      name.className = 'kr-jstack__name';
      name.innerHTML = '<i class="kr-jstack__dot"></i>';
      name.appendChild(document.createTextNode(st.name));
      var n = document.createElement('span');
      n.className = 'kr-jstack__n';
      n.textContent = plural(st.n, 'photo');
      el.appendChild(pile);
      el.appendChild(name);
      el.appendChild(n);
      stacksEl.appendChild(el);
      return { el: el, pile: pile, cards: cards, pin: pinOf[st.pin], at: { x: 0, y: 0, w: 0, h: 0 }, to: { x: 0, y: 0 }, c: {} };
    });
    // ── the photos that fly: each leaves its stack from under the pile, goes
    // over and drops onto the stack's pin ──
    var flights = [];
    DATA.stacks.forEach(function (st, i) {
      st.fly.forEach(function (cell, j) {
        var el = document.createElement('i');
        el.className = 'kr-jhow__fly';
        el.setAttribute('aria-hidden', 'true');
        photoBg(el, cell);
        stage.insertBefore(el, line);
        flights.push({ el: el, stack: i, j: j, off: st.fly.length > 1 ? j / (st.fly.length - 1) : 0, t: 0, c: {} });
      });
    });
    if (tag) {
      tag.style.setProperty('--c', pinOf[DATA.one.pin].c);
      var words = tag.querySelector('b');
      if (words) words.textContent = DATA.one.tag;
    }

    // ── the tap ──
    var tapPin = pinOf[DATA.tap];
    var tap = document.createElement('i');
    tap.className = 'kr-jtap';
    tap.setAttribute('aria-hidden', 'true');
    tap.style.left = tapPin.x + 'px';
    tap.style.top = tapPin.y - MAP_TOP - HEAD + 'px';
    map.appendChild(tap);

    // ── where things are on the stage (fit), in its own px ──
    var k = 0.72;                       // the screen: px a point
    var O = { x: 0, y: 0 };             // and where its corner (0, 0) is, the phone at rest
    var lens = { x: 0, y: 0, w: 0, h: 0 };
    var appH = H, offY = 0;             // how much of the screen's height the lens shows, and from where
    var cam = null;                     // the camera's two ends (fit)
    var rise = 0, riseMax = 0;          // how far under its place the phone is now
    var cardAt = { x: 0, y: 0, w: 0 };  // the one photo at rest: its middle, and its width
    var pinAt = { x: 0, y: 0 };         // the head of the pin it belongs to
    var bump = 1;
    var upright = false;

    // ── one frame, from how far along each moment is (S) and where the
    // scroll is in the section (at); the time (now) only moves the camera's
    // live view ──
    var S = [0, 0, 0, 0, 0, 0, 0, 0, 0];
    var at = 0;
    var running = false;      // true once the story follows the scroll
    var cc = {};              // what was last written, so nothing is written twice
    var lastSay = -1, lastCount = -1;
    function render(now) {
      var fly = S[FLY], rai = S[RAISE], cap = S[CAPTURE], det = S[DETECT], rev = S[REVEAL], pho = S[PHOTOS], trp = S[TRIP], opn = S[OPEN], rd = S[READ];
      var i, j, t, e;
      if (!cam) return;

      // fly: from the whole print to the pins. The zoom is even to the eye
      // (so much larger for each step of the scroll), and what the camera
      // looks at goes in a straight line across the stage.
      e = gentle(fly);
      var sg = cam.s0 * Math.pow(cam.s1 / cam.s0, e);
      var w = cam.s1 === cam.s0 ? 1 : (1 / cam.s0 - 1 / sg) / (1 / cam.s0 - 1 / cam.s1);
      var ax = cam.A0[0] + (cam.A1[0] - cam.A0[0]) * w, ay = cam.A0[1] + (cam.A1[1] - cam.A0[1]) * w;
      var sx = cam.S0[0] + (cam.S1[0] - cam.S0[0]) * w, sy = cam.S0[1] + (cam.S1[1] - cam.S0[1]) * w;
      set(wall, 'transform', 'translate(' + (sx - ax * sg).toFixed(2) + 'px,' + (sy - ay * sg).toFixed(2) + 'px) scale(' + sg.toFixed(5) + ')', cc, 'wall');
      var real = smooth(0.4, 0.82, e).toFixed(3);
      for (i = 0; i < wallImgs.length; i++) set(wallImgs[i], 'opacity', real, cc, 'real' + i);
      var dotK = clamp(24 * sg, 3.5, 10) / (10 * sg), dotOp = (1 - smooth(0.45, 0.8, e)).toFixed(3);
      for (i = 0; i < dots.length; i++) {
        set(dots[i].el, 'transform', 'scale(' + dotK.toFixed(4) + ')', dots[i].c, 'tf');
        set(dots[i].el, 'opacity', dotOp, dots[i].c, 'op');
      }
      set(lamp, 'opacity', (1 - 0.7 * e).toFixed(3), cc, 'lamp');
      // Beside the words, the veil they stand on comes as the map comes under them: the print, whole, is not in its shade.
      set(veil, 'opacity', upright ? '1' : smooth(0.05, 0.5, e).toFixed(3), cc, 'veil');

      // raise: the phone comes up over the pins, showing the wall behind it.
      var up = still ? 1 : rai;
      rise = (1 - easeOut(up)) * riseMax;
      set(phone, 'transform', rise > 0.05 ? 'translateY(' + rise.toFixed(2) + 'px)' : 'none', cc, 'rise');
      set(phone, 'opacity', Math.min(1, up * 3).toFixed(3), cc, 'phoneOp');
      set(phone, 'visibility', up > 0 ? 'visible' : 'hidden', cc, 'phoneV');
      var seen = still ? 0 : smooth(0.35, 1, rai) * (1 - part(rev, 0, 0.1));
      set(vf, 'opacity', seen.toFixed(3), cc, 'vf');

      // capture: the handheld drift settles as the shutter goes. The view
      // also makes up for the phone's own way up, so that what it shows is
      // what is behind it.
      var drift = seen * (1 - easeOut(part(cap, 0, 0.3)));
      var tt = now / 1000, back = -rise / k;
      set(view, 'transform', drift > 0.001
        ? 'translate(' + (1.8 * Math.sin(tt * 0.9) * drift).toFixed(2) + 'px,' + (back + 1.3 * Math.sin(tt * 1.23 + 1.1) * drift).toFixed(2) + 'px) rotate(' + (0.22 * Math.sin(tt * 0.71 + 0.4) * drift).toFixed(3) + 'deg) scale(' + (1 + 0.018 * drift).toFixed(4) + ')'
        : back < -0.05 ? 'translateY(' + back.toFixed(2) + 'px)' : 'none', cc, 'view');
      var press = part(cap, 0.1, 0.22), release = part(cap, 0.36, 0.3);
      set(shutter, 'transform', 'scale(' + (1 - 0.16 * easeOut(press) + 0.16 * easeBack(release)).toFixed(3) + ')', cc, 'shutter');
      set(blink, 'opacity', (0.78 * bell(part(cap, 0.28, 0.4))).toFixed(3), cc, 'blink');
      var read = easeOut(part(cap, 0.7, 0.3));
      set(found, 'opacity', read.toFixed(3), cc, 'found');
      set(found, 'transform', 'translateY(' + ((1 - read) * 8).toFixed(1) + 'px)', cc, 'foundT');

      // detect: the light passes, the rest dims, each pin found.
      set(dim, 'opacity', (easeOut(part(det, 0.04, 0.3)) * (1 - easeOut(part(rev, 0.02, 0.12)))).toFixed(3), cc, 'dim');
      var sw = easeInOut(part(det, DET[0], DET[1]));
      set(shimmer, 'opacity', (0.9 * bell(part(det, DET[0], DET[1]))).toFixed(3), cc, 'shOp');
      set(shimmer, 'backgroundPosition', ((1 - sw) * 100).toFixed(2) + '% 0', cc, 'shPos');
      var count = 0, layers = [], done = still || rev >= RING_END;
      for (i = 0; i < finds.length; i++) {
        var f = finds[i];
        var pop = part(det, f.tFind, 0.14);
        if (det >= f.tFind + 0.03) count++;
        // reveal: its ring starts; the halo closes onto the rising pin.
        var close_ = part(rev, f.tRing, 0.07);
        var ec = easeOut(close_);
        var ringScale = (0.55 + 0.45 * easeBack(pop)) * (1 - (1 - f.to) * ec);
        set(f.el, 'opacity', (pop <= 0 ? 0 : Math.min(1, pop * 3) * (1 - part(close_, 0.5, 0.5))).toFixed(3), f.c, 'op');
        set(f.el, 'transform', 'translateY(' + (-HEAD * ec).toFixed(1) + 'px) scale(' + ringScale.toFixed(3) + ')', f.c, 'tf');
        var holeR = f.R * easeOut(part(det, f.tFind - 0.02, 0.16));
        if (f.c.r !== holeR) { f.c.r = holeR; f.hole.setAttribute('r', holeR.toFixed(1)); }
        var g1 = bell(part(det, f.tFind, 0.22)) * 0.55, g2 = bell(part(rev, f.tRing, 0.1)) * 0.95;
        set(f.glow, 'opacity', Math.max(g1, g2).toFixed(3), f.c, 'gop');
        set(f.glow, 'transform', 'translateY(' + (g2 > g1 ? -HEAD : 0) + 'px) scale(' + (0.6 + 0.7 * (g2 > g1 ? part(rev, f.tRing, 0.1) : part(det, f.tFind, 0.22))).toFixed(3) + ')', f.c, 'gtf');
        // The ring the map comes out in, and the light on its edge.
        var gr = part(rev, f.tRing, RING_LEN);
        var R = RING_R * (1 - Math.pow(1 - gr, 1.6));
        if (!done && R > 0.5) layers.push('radial-gradient(circle at ' + f.p.x + 'px ' + f.p.y + 'px, #000 0, #000 ' + R.toFixed(1) + 'px, rgba(0,0,0,0) ' + (R + 36).toFixed(1) + 'px)');
        var rop = !done && R > 0.5 ? Math.min(1, R / 30) * (1 - R / RING_R) * 0.95 : 0;
        set(f.ripple, 'opacity', rop.toFixed(3), f.rc, 'op');
        if (rop > 0) {
          set(f.ripple, 'left', (f.p.x - R).toFixed(1) + 'px', f.rc, 'l');
          set(f.ripple, 'top', (f.p.y - R).toFixed(1) + 'px', f.rc, 't');
          set(f.ripple, 'width', (2 * R).toFixed(1) + 'px', f.rc, 'w');
          set(f.ripple, 'height', (2 * R).toFixed(1) + 'px', f.rc, 'h');
        }
      }
      if (count !== lastCount) {
        lastCount = count;
        foundTx.textContent = count ? plural(count, 'pin') + ' found' : 'Reading your photo';
      }
      mask(digital, done ? 'none' : layers.length ? layers.join(', ') : 'linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0))', cc);
      set(view, 'visibility', done ? 'hidden' : 'visible', cc, 'viewV');

      // The pins: each rises out of the photograph as its ring starts.
      for (i = 0; i < pins.length; i++) {
        var st = pins[i];
        t = still ? 1 : part(rev, st.find.tRing + 0.005, 0.09);
        e = easeBack(t);
        set(st.el, 'opacity', (t <= 0 ? 0 : Math.min(1, t * 3)).toFixed(3), st.c, 'op');
        set(st.el, 'transform', 'translateY(' + ((1 - e) * HEAD * 0.5).toFixed(1) + 'px) scale(' + ((0.5 + 0.5 * e) * PIN).toFixed(3) + ')', st.c, 'tf');
      }
      // The app round its map: its header comes down, its tabs come up.
      if (running) {
        var bars = easeOut(part(rev, RING_END - 0.08, 1 - (RING_END - 0.08)));
        set(hdr, 'transform', 'translateY(' + ((bars - 1) * 101).toFixed(2) + '%)', cc, 'hdr');
        set(tab, 'transform', 'translateY(' + ((1 - bars) * 101).toFixed(2) + '%)', cc, 'tab');
      }

      // photos: the wall goes out of focus; one photo, its line, its pin.
      var blur = still ? 1 : easeInOut(part(pho, 0, 0.1));
      set(soft, 'opacity', blur.toFixed(3), cc, 'soft');
      set(shade, 'opacity', (0.12 * Math.min(1, up * 2) + 0.12 * smooth(0, 0.2, rev) + 0.24 * blur).toFixed(3), cc, 'shade');
      var inn = easeOut(part(pho, ONE_IN[0], ONE_IN[1]));
      var drawn = easeInOut(part(pho, ONE_LINE[0], ONE_LINE[1]));
      var go = easeInOut(part(pho, ONE_FLY[0], ONE_FLY[1]));
      var landed = part(go, 0.86, 0.14);
      var dx = (pinAt.x - cardAt.x) * go + (upright ? 0 : 36) * (1 - inn);
      var dy = (pinAt.y - cardAt.y) * go + (upright ? 30 : 0) * (1 - inn);
      var cs = 1 - 0.93 * go;
      set(card, 'opacity', (inn * (1 - landed)).toFixed(3), cc, 'cardOp');
      set(card, 'transform', 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + cs.toFixed(4) + ')', cc, 'cardTf');
      set(tag, 'opacity', (inn * (1 - part(pho, ONE_FLY[0] - 0.04, 0.05))).toFixed(3), cc, 'tagOp');
      set(tag, 'transform', 'translate(' + ((upright ? 0 : 36) * (1 - inn)).toFixed(1) + 'px,' + ((upright ? 30 : 0) * (1 - inn)).toFixed(1) + 'px)', cc, 'tagTf');
      // The line runs from the pin's halo to the photo's middle, under the photo.
      var ex = cardAt.x + dx - pinAt.x, ey = cardAt.y + dy - pinAt.y;
      var len = Math.sqrt(ex * ex + ey * ey), hr = 16 * bump;
      set(line, 'opacity', (drawn * (1 - landed)).toFixed(3), cc, 'lineOp');
      set(line, 'width', Math.max(0, len - hr).toFixed(1) + 'px', cc, 'lineW');
      set(line, 'transform', 'translate(' + pinAt.x.toFixed(1) + 'px,' + pinAt.y.toFixed(1) + 'px) rotate(' + Math.atan2(ey, ex).toFixed(4) + 'rad) translateX(' + hr.toFixed(1) + 'px) scaleX(' + drawn.toFixed(4) + ')', cc, 'lineTf');
      set(halo, 'opacity', (drawn * (1 - landed)).toFixed(3), cc, 'haloOp');
      set(halo, 'transform', 'translate(' + pinAt.x.toFixed(1) + 'px,' + pinAt.y.toFixed(1) + 'px) scale(' + ((1.5 - 0.5 * drawn) * (1 - 0.45 * landed) * bump).toFixed(3) + ')', cc, 'haloTf');

      // The stacks, one pin after another; from each, photos fly onto its pin.
      var leave = 1 - part(trp, 0.04, 0.24);
      var any = 0;
      var inn_ = [], of_ = [];      // each stack's photos: how far landed, and how many
      for (i = 0; i < stacks.length; i++) { inn_.push(0); of_.push(0); }
      for (i = 0; i < flights.length; i++) {
        var fg = flights[i], from = stacks[fg.stack];
        t = fg.t = still ? 1 : part(pho, STACK_0 + fg.stack * STACK_STEP + FLY_0 + fg.off * FLY_SPREAD, FLY_LEN);
        inn_[fg.stack] += part(t, 0.84, 0.16);
        of_[fg.stack]++;
        if (t <= 0 || t >= 1 || !from.at.w) { set(fg.el, 'opacity', '0', fg.c, 'op'); continue; }
        var u = gentle(t), v = 1 - u;
        var hx = (from.at.x + from.to.x) / 2, hy = Math.min(from.at.y, from.to.y) - (upright ? 26 : 54) - (fg.j % 2) * 16;
        var fx = v * v * from.at.x + 2 * v * u * hx + u * u * from.to.x;
        var fy = v * v * from.at.y + 2 * v * u * hy + u * u * from.to.y;
        var small = (2.7 * HEAD_R * k * bump) / from.at.w;
        var fs = 1 - (1 - small) * smooth(0.2, 1, t);
        set(fg.el, 'opacity', (t < 0.12 ? t / 0.12 : t > 0.9 ? (1 - t) / 0.1 : 1).toFixed(3), fg.c, 'op');
        set(fg.el, 'transform', 'translate(' + (fx - from.at.w / 2).toFixed(1) + 'px,' + (fy - from.at.h / 2).toFixed(1) + 'px) rotate(' + (((fg.j % 3) - 1) * 6 * v).toFixed(1) + 'deg) scale(' + fs.toFixed(4) + ')', fg.c, 'tf');
      }
      for (i = 0; i < stacks.length; i++) {
        var sk_ = stacks[i];
        var a = still ? 1 : easeOut(part(pho, STACK_0 + i * STACK_STEP, STACK_IN));
        if (a > any) any = a;
        set(sk_.el, 'opacity', (a * leave).toFixed(3), sk_.c, 'op');
        set(sk_.el, 'transform', 'translateY(' + ((1 - a) * 26).toFixed(1) + 'px)', sk_.c, 'tf');
        for (j = 0; j < sk_.cards.length; j++) {
          var cd = sk_.cards[j], fan = FAN[j % FAN.length];
          set(cd.el, 'transform', 'translate(' + (fan[1] * a * 100).toFixed(2) + '%,' + (fan[2] * a * 100).toFixed(2) + '%) rotate(' + (fan[0] * a).toFixed(2) + 'deg)', cd.c, 'tf');
        }
      }
      set(stacksEl, 'opacity', (Math.min(1, any * 2) * leave).toFixed(3), cc, 'stacksOp');
      for (i = 0; i < badges.length; i++) {
        var b = badges[i];
        var had = b.first && (still || landed >= 1) ? 1 : 0;
        var got = of_[b.i] ? inn_[b.i] / of_[b.i] : 0;  // its photos, as they land
        var num = Math.round(had + (b.total - had) * got);
        var grow = b.first ? Math.max(still ? 1 : part(go, 0.9, 0.1), got > 0 ? 1 : 0) : clamp(got * 6, 0, 1);
        var size = (grow > 0 ? easeBack(grow) * bump : 0).toFixed(3);
        var key = num + ':' + size;
        if (key === b.last) continue;
        b.last = key;
        b.el.textContent = Math.max(1, num);
        b.el.style.transform = 'translate(' + b.tx + ',-50%) scale(' + size + ')';
      }

      // trip: a fingertip presses the pin and lifts; the route draws itself
      // through the pins.
      var tp = part(trp, 0, 0.3);
      var pr = tp < 0.35 ? easeOut(tp / 0.35) : 1, lift = tp < 0.35 ? 0 : easeOut((tp - 0.35) / 0.65);
      set(tap, 'opacity', (tp > 0 && tp < 1 ? pr * (1 - lift) : 0).toFixed(3), cc, 'tapOp');
      set(tap, 'transform', 'scale(' + ((1.35 - 0.45 * pr + 0.8 * lift) * bump).toFixed(3) + ')', cc, 'tapT');
      var each = 0.6 / Math.max(1, segs.length);
      for (i = 0; i < segs.length; i++) {
        var off = (segs[i].n * (1 - gentle(part(trp, 0.26 + i * each, each)))).toFixed(1);
        if (segs[i].c.off !== off) {
          segs[i].c.off = off;
          segs[i].els[0].style.strokeDashoffset = off;
          segs[i].els[1].style.strokeDashoffset = off;
        }
      }

      // open: the trip's page comes in from the right, the map tab sliding
      // off under it as the app's screens do. Once it is in, no transform is
      // left on it: held upright, its Play stands fixed over the whole screen.
      var o = still ? 1 : easeOutQuint(opn);
      set(demoEl, 'transform', o >= 1 ? 'none' : 'translateX(' + ((1 - o) * 100).toFixed(2) + '%)', cc, 'demoTf');
      set(demoEl, 'visibility', o > 0 ? 'visible' : 'hidden', cc, 'demoV');
      setVar(screen, '--push', (-0.3 * o * lens.w).toFixed(1) + 'px', cc, 'push');

      // read: the page's own scroll, from where the pin was reached to the
      // day's last photo, driven by the section's; the camera keeps to the
      // trace at each point. Beside the phone, the place the photos are at.
      var sOff = D ? (still ? D.start : readMap(rd)) : 0;
      var free = still || at >= FREE;    // yours: at the end the stage lets the page go
      if (demo && D && !free) demo.drive(sOff);
      set(place, 'opacity', (still ? 1 : easeInOut(part(opn, 0.25, 0.75))).toFixed(3), cc, 'place');
      for (i = 1; i < placeImgs.length; i++) {
        var pv = D && D.places[i - 1] ? smooth(D.places[i - 1][0], D.places[i - 1][1], sOff) : 0;
        set(placeImgs[i], 'opacity', pv.toFixed(3), cc, 'place' + i);
      }
      if (demo && cc.free !== free) {
        cc.free = free;
        demo.hold(!free);
        if (!free && D) demo.drive(sOff);    // scrolled back, the story has it again
      }

      // The words, and the three parts over them.
      var say = 0;
      for (i = 0; i < SAYS.length; i++) if (at >= SAYS[i]) say = i;
      if (say !== lastSay) {
        lastSay = say;
        says.forEach(function (el, n) { el.classList.toggle('is-on', n === say); });
        parts.forEach(function (el, n) { el.classList.toggle('is-on', n <= PART_OF[say]); });
      }
      for (i = 0; i < parts.length; i++) set(parts[i], 'cssText', '--p:' + part(at, PARTS[i][0], PARTS[i][1] - PARTS[i][0]).toFixed(4), cc, 'part' + i);
    }

    // ── the screen, laid out at the app's size and scaled to the lens (the
    // phone's screen, or the width of a screen held upright, which shows the
    // middle of the app's); the camera's two ends; where the photos go. On a
    // small phone the counts, the halo and the tap are drawn larger than the
    // app's, or they'd be too small to make out ──
    function fit() {
      var g = stage.getBoundingClientRect(), sr = screen.getBoundingClientRect();
      if (!sr.width || !sr.height) return;
      upright = !!tall.matches;
      k = Math.max(sr.width / W, sr.height / H);
      var appW = sr.width / k, offX = (W - appW) / 2;
      appH = sr.height / k;
      var hdrH = upright ? 67 : MAP_TOP, tabH = upright ? 72 : H - MAP_BOT;
      offY = clamp(Math.max(MAP_TOP - hdrH, CY - appH / 2), 0, Math.max(0, H - appH));
      phone.style.setProperty('--k', k.toFixed(5));
      phone.style.setProperty('--ox', px(-offX));
      phone.style.setProperty('--oy', px(-offY));
      phone.style.setProperty('--aw', px(appW));
      phone.style.setProperty('--ah', px(appH));
      hdr.style.height = hdrH + 'px';
      hdr.style.backgroundPosition = px(-offX) + ' ' + (hdrH - MAP_TOP) + 'px';
      tab.style.height = tabH + 'px';
      tab.style.backgroundPosition = px(-offX) + ' ' + -MAP_TOP + 'px';     // in the bars' image the tab bar is under the header
      bump = Math.max(1, Math.min(1.6, 0.74 / k));
      lens = { x: sr.left - g.left, y: sr.top - g.top - rise, w: sr.width, h: sr.height };
      O = { x: lens.x - offX * k, y: lens.y - offY * k };

      // The camera: from the framed print, whole, in the room the words leave
      // it, to the pins where the lens is.
      var hero;
      if (upright) hero = { x: 18, y: lens.y + 6, w: g.width - 36, h: lens.h - 12, at: 0.44 };
      else {
        var left = copy.getBoundingClientRect().right - g.left + 28;
        hero = { x: left, y: 48, w: Math.max(200, g.width - left - 40), h: g.height - 96, at: 0.5 };
      }
      cam = {
        s0: Math.min(hero.w / (A.w + 2 * A.frame), hero.h / (A.h + 2 * A.frame)),
        s1: k / A.k,
        A0: [A.w / 2, A.h / 2],
        S0: [hero.x + hero.w / 2, hero.y + hero.h * hero.at],
        A1: [A.x + (offX + appW / 2) * A.k, A.y + (offY + appH / 2) * A.k],
        S1: [lens.x + lens.w / 2, lens.y + lens.h / 2]
      };
      if (cam.s0 > cam.s1) cam.s0 = cam.s1;
      lamp.style.background = 'radial-gradient(ellipse ' + (hero.w * 0.7).toFixed(0) + 'px ' + (hero.h * 0.9).toFixed(0) + 'px at ' + cam.S0[0].toFixed(0) + 'px ' + cam.S0[1].toFixed(0) + 'px, rgba(255,222,176,0.16), rgba(255,222,176,0) 70%)';
      riseMax = upright ? 0 : Math.min(0.32 * g.height, 300);

      var p = pinOf[DATA.one.pin];
      pinAt = { x: O.x + k * p.x, y: O.y + k * (p.y - HEAD) };
      if (one && card) {
        // Beside the phone, the photo stands level with its pin; held upright, the stylesheet places it.
        card.style.transform = 'none';
        one.style.top = '';
        if (!upright) {
          var side = one.parentNode.getBoundingClientRect();
          var want = pinAt.y - card.offsetHeight / 2 - (side.top - g.top);
          one.style.top = clamp(want, 0, Math.max(0, side.height - one.offsetHeight)).toFixed(1) + 'px';
        }
        var c = card.getBoundingClientRect();
        cardAt = { x: c.left - g.left + c.width / 2, y: c.top - g.top + c.height / 2, w: c.width };
      }
      // Each stack's pile at rest, and its pin's head: where its photos fly from and to.
      stacks.forEach(function (sk) {
        sk.el.style.transform = 'none';
        var r = sk.pile.getBoundingClientRect();
        sk.at = { x: r.left - g.left + r.width / 2, y: r.top - g.top + r.height / 2, w: r.width, h: r.height };
        sk.to = { x: O.x + k * sk.pin.x, y: O.y + k * (sk.pin.y - HEAD) };
        sk.c = {};
      });
      flights.forEach(function (fg) {
        var from = stacks[fg.stack].at;
        fg.el.style.width = from.w.toFixed(1) + 'px';
        fg.el.style.height = from.h.toFixed(1) + 'px';
        fg.c = {};
      });
      // The trip's page, in the app's points: a point is the screen's width
      // over the app's 393; held upright its Play fills the visitor's screen.
      if (demoEl) {
        demoEl.style.setProperty('--u', (sr.width / 393).toFixed(5) + 'px');
        root.style.setProperty('--up', Math.min(window.innerWidth / 393, window.innerHeight / 852).toFixed(5) + 'px');
        if (demo) demo.fit();
      }
      cc = {};
      badges.forEach(function (b) { b.last = ''; });
      root.classList.add('is-set');
      if (running) kick();
    }

    if (still) {
      // Standing still: the trip's page open in the phone, to scroll, over
      // the place; and every moment's words listed.
      S = [1, 1, 1, 1, 1, 1, 1, 1, 0];
      at = PARTS[2][0];
      fit();
      if (window.ResizeObserver) new ResizeObserver(function () { fit(); render(0); }).observe(stage);
      render(0);
      inited = true;
      if (demo) { demo.wake(); demo.hold(false); }
      return;
    }

    root.classList.add('is-scroll');
    running = true;
    var stickTop = 0;
    function measureTop() { stickTop = parseFloat(getComputedStyle(stage).top) || 0; }
    function progress() {
      var total = track.offsetHeight - stage.offsetHeight;
      return total > 0 ? clamp((stickTop - track.getBoundingClientRect().top) / total, 0, 1) : 0;
    }
    function topOf(share) {
      return Math.round(window.pageYOffset + track.getBoundingClientRect().top - stickTop + share * (track.offsetHeight - stage.offsetHeight));
    }

    // The story follows the scroll: where the stage is (cur) closes on where
    // the page is each frame (by the same share a second at any frame rate),
    // and each moment is its share of that. While the visitor skips, the
    // stage keeps the frame it had, and goes by as any section does.
    var raf = 0, nearBy = false, cur = -1, last = 0, skipping = false;
    function tick(now) {
      raf = 0;
      if (skipping) { last = 0; return; }
      var target = progress();
      var d = target - cur;
      var dt = last ? Math.min(0.1, (now - last) / 1000) : 1 / 60;
      last = now;
      cur = cur < 0 || Math.abs(d) < 0.0004 ? target : cur + d * (1 - Math.pow(1 - EASE, dt * 60));
      for (var i = 0; i < S.length; i++) S[i] = part(cur, SCENES[i][0], SCENES[i][1] - SCENES[i][0]);
      at = cur;
      render(now);
      // Keep going while the stage catches up, or the camera is live on screen.
      if (cur !== target || (nearBy && S[RAISE] > 0.35 && S[CAPTURE] < 0.3)) raf = requestAnimationFrame(tick);
      else last = 0;
    }
    function kick() { if (!raf) raf = requestAnimationFrame(tick); }

    // ── the way out. Skip leaves the section the way the visitor is going:
    // down to what comes after it, or back up to what came before ──
    var goingUp = false, turn = window.pageYOffset, idle = 0, giveUp = 0;
    function heading() {
      var y = window.pageYOffset, was = goingUp;
      if (goingUp ? y < turn : y > turn) turn = y;
      else if (Math.abs(y - turn) > 60) {
        goingUp = !goingUp;
        turn = y;
      }
      // At the section's start there is nothing above to skip to.
      if (goingUp && progress() <= 0) { goingUp = false; turn = y; }
      if (goingUp !== was && skip) skip.classList.toggle('is-up', goingUp);
    }
    function skipped() {
      if (!skipping) return;
      skipping = false;
      clearTimeout(idle);
      clearTimeout(giveUp);
      turn = window.pageYOffset;
      kick();
    }
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
      window.addEventListener(type, skipped, { passive: true });
    });
    if (skip) {
      skip.addEventListener('click', function (ev) {
        ev.preventDefault();
        ev.stopPropagation();
        var to = goingUp
          ? Math.max(0, topOf(0) + stickTop - window.innerHeight)     // the section's top at the window's foot
          : Math.round(window.pageYOffset + track.getBoundingClientRect().bottom - stickTop);
        skipping = true;
        window.scrollTo({ top: to, behavior: 'smooth' });
        clearTimeout(giveUp);
        giveUp = setTimeout(skipped, 3000);
        if (!goingUp && end && end.focus) end.focus({ preventScroll: true });
      });
      skip.addEventListener('mousedown', function (ev) { ev.stopPropagation(); });
      skip.addEventListener('keydown', function (ev) { ev.stopPropagation(); });
    }
    function onScroll() {
      if (skipping) {
        // Done when the page has stopped.
        clearTimeout(idle);
        idle = setTimeout(skipped, 160);
        return;
      }
      heading();
      kick();
    }

    fit();
    if (window.ResizeObserver) new ResizeObserver(fit).observe(stage);
    else window.addEventListener('resize', fit);
    if (tall.addEventListener) tall.addEventListener('change', fit);
    measureTop();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measureTop(); kick(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        nearBy = es[0].isIntersecting;
        if (nearBy) {
          kick();
          // The trip's map loads now, well before the page comes in.
          if (demo) demo.wake();
          else wakeWanted = true;
        }
      }, { rootMargin: '200px 0px' }).observe(stage);
    } else {
      nearBy = true;
    }
    render(performance.now());
    kick();
    inited = true;

    // A part's name scrolls to it.
    parts.forEach(function (b, j) {
      b.addEventListener('click', function () {
        window.scrollTo({ top: topOf(GOALS[j]), behavior: 'smooth' });
      });
    });
  }

  function start() { [].forEach.call(document.querySelectorAll('[data-kr-how]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // The theme editor puts a section back in when its settings change.
  document.addEventListener('shopify:section:load', start);
})();
